import * as DarkTheme from './dark'

export default DarkTheme
